import ECA from './views/eca.c';

export default ECA;
